export function invitationLink(origin: string, token: string): string {
  const url = new URL('/', origin);
  url.searchParams.set('invite', token);
  return url.toString();
}

export function invitationToken(search: string): string | null {
  return new URLSearchParams(search).get('invite');
}
